module.exports = __webpack_public_path__ + "static/media/icoSearch-1.75489eec.svg";